type Props = {
  // The price before promotions, already formatted by the caller.
  priceWithoutPromo?: string;
  promotions?: { id: string; name: string }[];
};

// Shown in the price column, just above a list price that includes
// promotions: the price before them, crossed out; hovering it names them.
// The card's promotion count already flags the hotel, so no pill here.
// Renders nothing when no promotion is included.
const PromotionIncludedPrice = ({ priceWithoutPromo, promotions }: Props) => {
  if (!priceWithoutPromo || !promotions?.length) return null;

  const names = promotions
    .map((promotion) => promotion.name)
    .filter(Boolean)
    .join(', ');

  return (
    <span className="text-xs text-gray-400 line-through" title={names}>
      {priceWithoutPromo}
    </span>
  );
};

export default PromotionIncludedPrice;
